<template>
    <router-view />
    <ModalContainer />
    <NewVersionBanner />
</template>

<script>
import ModalContainer from './components/ModalContainer.vue';
import NewVersionBanner from './components/NewVersionBanner.vue';

export default {
    name: 'App',

    components: {
        ModalContainer,
        NewVersionBanner
    },

    mounted() {
        if (window.message) {
            this.$buefy.snackbar.open({
                duration: 5000,
                message: window.message,
                type: 'is-success',
                position: 'is-top',
                actionText: 'OK'
            });
        }
    }
};
</script>
